'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  Instrument,
  ProfileSkillLevelSchema,
  SkillLevelsArraySchema,
  StudySessions,
  StudySessionsOptions,
} from '../types';

interface OnboardingState {
  selectedInstrument: { instrumentName: string | null };
  childInstrument: { instrumentName: string | null }; // nuovo attributo
  instruments: Instrument[];
  isLoading: boolean;
  error: Error | null;

  profileStudySessions: StudySessions[0] | null;
  studySessionsOptions: StudySessionsOptions | null;
  skillLevelsOptions: SkillLevelsArraySchema | null;
  profileSkillLevel: ProfileSkillLevelSchema | null;

  setSelectedInstrument(instrument: { instrumentName: string | null }): void;
  setChildInstrument(child: { instrumentName: string | null }): void; // nuovo setter

  setInstruments(instruments: Instrument[]): void;
  setIsLoading(loading: boolean): void;
  setError(error: Error | null): void;
  resetStore(): void;

  setProfileStudySessions: (profileStudySessions: StudySessions[0] | null) => void;
  setStudySessionsOptions: (sessionOptions: StudySessionsOptions | null) => void;
  setSkillLevelsOptions: (cs: SkillLevelsArraySchema | null) => void;
  setProfileSkillLevel: (profileSkillLevels: ProfileSkillLevelSchema | null) => void;
}

const initialState = {
  selectedInstrument: { instrumentName: null },
  childInstrument: { instrumentName: null }, // inizializzato null
  instruments: [] as Instrument[],
  isLoading: false,
  error: null as Error | null,
  studySessionsOptions: null,
  profileStudySessions: null,
  skillLevelsOptions: null,
  profileSkillLevel: null,
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      ...initialState,

      setSelectedInstrument: (instrument) => {
        set({ selectedInstrument: instrument });
      },

      setChildInstrument: (child) => {
        set({ childInstrument: child });
      },

      setInstruments: (instruments) => {
        set({ instruments });
      },

      setProfileStudySessions: (profileStudySessions: StudySessions[0] | null) =>
        set({ profileStudySessions }),

      setStudySessionsOptions: (studySessionsOptions: StudySessionsOptions | null) =>
        set({ studySessionsOptions }),

      setSkillLevelsOptions: (skillLevelsOptions) => set({ skillLevelsOptions }),

      setProfileSkillLevel: (profileSkillLevel) => set({ profileSkillLevel }),

      setIsLoading: (loading) => {
        set({ isLoading: loading });
      },

      setError: (error) => {
        set({ error });
      },

      resetStore: () => {
        set({ ...initialState });
      },
    }),
    {
      name: 'onboarding-storage',
      partialize: (state) => ({
        selectedInstrument: state.selectedInstrument,
        childInstrument: state.childInstrument,
        instruments: state.instruments,
        profileStudySessions: state.profileStudySessions,
        skillLevelsOptions: state.skillLevelsOptions,
        profileSkillLevel: state.profileSkillLevel,
      }),
    },
  ),
);
